import { render, staticRenderFns } from "./BigToggleButton.vue?vue&type=template&id=12e4d8b3&scoped=true"
import script from "./BigToggleButton.vue?vue&type=script&lang=js"
export * from "./BigToggleButton.vue?vue&type=script&lang=js"
import style0 from "./BigToggleButton.vue?vue&type=style&index=0&id=12e4d8b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4d8b3",
  null
  
)

export default component.exports